export default __webpack_public_path__ + "1dc44f03eaecb7c97e454af742b99f32.png";